import React, { Component } from 'react';

import config from '../../config';
import * as log from '../../util/log';
// Imported directly, not through the loadable index: the error page must show even when code
// chunks can't load.
import ErrorPage from '../ErrorPage/ErrorPage';

// A page that crashes while rendering shows the 500 page instead of a blank screen.
// https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
export class LoadableComponentErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, eventId: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    // A ChunkLoadError means a deploy replaced the page's code while the app was open: "Try
    // again" (a reload) fixes it, and it isn't a bug to report.
    if (error?.name === 'ChunkLoadError') {
      return;
    }
    log
      .error(error, 'render-error', { componentStack: errorInfo?.componentStack })
      .then(eventId => {
        if (eventId) {
          this.setState({ eventId });
        }
      });
  }

  render() {
    if (this.state.error) {
      return <ErrorPage errorReference={this.state.eventId} />;
    }

    return this.props.children;
  }
}

// In development mode with Hot Module Reloading (HMR) in use, the boundary causes error loops, and
// React's own error overlay is more useful there.
const UseLoadableErrorBoundaryOnlyInProdutionMode = props => {
  const { children } = props;
  return config.dev ? (
    children
  ) : (
    <LoadableComponentErrorBoundary>{children}</LoadableComponentErrorBoundary>
  );
};
export default UseLoadableErrorBoundaryOnlyInProdutionMode;
